export default __webpack_public_path__ + "0bb7a80660c8115454c670a01f77ca8f.png";